enum VouchersActions {
    FETCH_LIST = "vouchersFetchList",
    GET_ITEM = "vouchersGetItem",
    CREATE_ITEM = "vouchersCreateItem",
    UPDATE_ITEM = "vouchersUpdateItem",
    DEACTIVATE_ITEM = "vouchersDeactivateItem",
    REFRESH_LIST = "vouchersRefreshList",
    GENERATE_CODE = "vouchersGenerateCode",
    FETCH_PARTNERS = "vouchersFetchPartners",
    FETCH_CUSTOMER_GROUPS = "vouchersFetchCustomerGroups",
}

enum VouchersMutation {
    SET_RENDER_UPDATE = "vouchersListRenderNeeded",
    SET_LIST_RESULT = "vouchersListResult"
}

export {VouchersActions, VouchersMutation};
